// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compare-container {
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.compare-container h2 {
  color: var(--brand-accent, #d4af37);
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 300;
  text-align: center;
  margin-bottom: 30px;
}

.compare-status {
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  margin: 24px 0;
}

.compare-error {
  color: #b91c1c;
}

.comparison-table {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.table th {
  background: linear-gradient(45deg, #d4af37, #b8860b);
  color: #1a1a1a;
  padding: 15px;
  font-weight: 500;
  text-align: center;
  border-bottom: 2px solid rgba(212, 175, 55, 0.3);
}

.table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
  transition: background 0.3s ease;
}

.table td:first-child {
  background: #f8f9fa;
  font-weight: 500;
  text-align: left;
  color: #333;
}

.table tr:hover td {
  background: rgba(212, 175, 55, 0.05);
}

.table tr:last-child td {
  border-bottom: none;
}

.section-header td {
  background: #f8f9fa;
  font-weight: bold;
  color: #d4af37;
  border-top: 2px solid #d4af37;
}

.text-success {
  color: #28a745;
  font-weight: 500;
}

.text-danger {
  color: #dc3545;
  font-weight: 500;
}

@media (max-width: 768px) {
  .compare-container {
    padding: 15px;
  }
  .table th, .table td {
    padding: 8px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-browse-ui/rightbar/compare/compare.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;AACF;;AAEA;EACE,mCAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,oDAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAGA;EACE;IACE,aAAA;EAAF;EAGA;IACE,YAAA;IACA,eAAA;EADF;AACF","sourcesContent":[".compare-container {\n  padding: 20px;\n  background: rgba(255,255,255,0.95);\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1);\n}\n\n.compare-container h2 {\n  color: var(--brand-accent, #d4af37);\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  font-weight: 300;\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.compare-status {\n  text-align: center;\n  color: rgba(0, 0, 0, 0.6);\n  margin: 24px 0;\n}\n\n.compare-error {\n  color: #b91c1c;\n}\n\n.comparison-table {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n}\n\n.table th {\n  background: linear-gradient(45deg, #d4af37, #b8860b);\n  color: #1a1a1a;\n  padding: 15px;\n  font-weight: 500;\n  text-align: center;\n  border-bottom: 2px solid rgba(212,175,55,0.3);\n}\n\n.table td {\n  padding: 12px 15px;\n  border-bottom: 1px solid #f0f0f0;\n  text-align: center;\n  transition: background 0.3s ease;\n}\n\n.table td:first-child {\n  background: #f8f9fa;\n  font-weight: 500;\n  text-align: left;\n  color: #333;\n}\n\n.table tr:hover td {\n  background: rgba(212,175,55,0.05);\n}\n\n.table tr:last-child td {\n  border-bottom: none;\n}\n\n.section-header td {\n  background: #f8f9fa;\n  font-weight: bold;\n  color: #d4af37;\n  border-top: 2px solid #d4af37;\n}\n\n.text-success {\n  color: #28a745;\n  font-weight: 500;\n}\n\n.text-danger {\n  color: #dc3545;\n  font-weight: 500;\n}\n\n\n@media (max-width: 768px) {\n  .compare-container {\n    padding: 15px;\n  }\n\n  .table th, .table td {\n    padding: 8px;\n    font-size: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
